
import { defineComponent } from 'vue';
import NavigationItem from './NavigationItem/NavigationItem.vue';
export default defineComponent({
  name: 'NavigationItemsComponent',

  data() {
    return {
      navItems: [
        { id: 'pokedex', text: 'Pokédex', link: '/' },
        { id: 'search', text: 'Procurar por um Pokémon', link: '/search' },
      ],
    };
  },

  components: {
    NavigationItem,
  },
  props: {},
});
